import React from 'react'
import { createGlobalStyle } from 'styled-components'
import Colors from './Colors'
import { Body1Styles } from './Typography'

const Variables = createGlobalStyle`
  :root {
    --text-color: var(--leather-value);
    --bg-color: var(--white-value);
    --caption-color: var(--leather-value);
    --box-bg-opacity: 0.03;
  }
`

const ColorStyles = createGlobalStyle`
  /* Light mode */
  body {
    background: rgb(var(--bg-color));
    color: rgb(var(--text-color));
    transition:
      background 0.8s ease-in-out,
      color 0.8s ease-in-out;
  }

  /* OS dark mode — fallback for pages without an explicit theme */
  @media (prefers-color-scheme: dark) {
    :root:not([data-theme]) {
      --text-color: var(--white-value);
      --bg-color: var(--dark-leather-value);
      --caption-color: var(--white-value);
      --box-bg-opacity: 0.1;
    }
  }

  /* Explicit dark theme (set by AmbiencePresence) */
  :root[data-theme="dark"] {
    --text-color: var(--white-value);
    --bg-color: var(--dark-leather-value);
    --caption-color: var(--white-value);
    --box-bg-opacity: 0.1;
  }
`

const FontFixStyles = createGlobalStyle`
  body {
    -webkit-font-smoothing: antialiased;
    -moz-font-smoothing: antialiased;
  }
`

const AnchorStyles = createGlobalStyle`
  a,
  a:visited,
  a:active {
    color: inherit;
    text-decoration: underline;
  }

  a:hover {
    color: rgb(var(--tltr-awesome-value));
  }
`

const FocusStyles = createGlobalStyle`
  :focus-visible {
    outline: 2px solid rgb(var(--tltr-awesome-value));
    outline-offset: 3px;
    border-radius: 2px;
  }
`

const TextDecorationStyles = createGlobalStyle`
  html {
    ${Body1Styles}
    overflow-x: clip;
  }

  body {
    overflow-x: clip;
  }

  b,
  strong {
    font-weight: 700;
  }
`

const GlobalStyles = () => {
  return (
    <>
      <Colors />
      <Variables />
      <ColorStyles />
      <FontFixStyles />
      <AnchorStyles />
      <FocusStyles />
      <TextDecorationStyles />
    </>
  )
}

export default GlobalStyles
